export const classNames = (...args) => args.join(" ")